import { useContext, useEffect, useState } from "react";

import ShowErrorToastContext from "@context/showErrorToast/showErrorToastContext";
import HeaderBackButton from "@shared-ui-components/HeaderBackButton";
import { message } from "@src/constants";

import { getUserDetails, profileInitialState } from "./helper";
import ProfileList from "./ProfileList";

const Profile = () => {
  const [userData, setUserData] =
    useState<ProfileResponseType>(profileInitialState);

  const [loading, setLoading] = useState(true);

  const [{ showErrorToastSetState }] = useContext(ShowErrorToastContext);

  const getData = async () => {
    const res = await getUserDetails();
    if (!res.error) {
      setUserData(res?.data);
    } else {
      showErrorToastSetState({
        errorMessage: res?.error || "",
        errorTitle: message.ERROR_MESSAGE_DASHBOARD,
        open: true,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <HeaderBackButton title="Profile" />
      <ProfileList userData={userData} loading={loading} />
    </>
  );
};

export default Profile;
